/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Feedback_SendingInputs */

const en_feedback_sending = /** @type {(inputs: Feedback_SendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sending...`)
};

const zh_hans1_feedback_sending = /** @type {(inputs: Feedback_SendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`发送中……`)
};

const pt_br2_feedback_sending = /** @type {(inputs: Feedback_SendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enviando...`)
};

const es_feedback_sending = /** @type {(inputs: Feedback_SendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enviando...`)
};

const fr_feedback_sending = /** @type {(inputs: Feedback_SendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Envoi...`)
};

const de_feedback_sending = /** @type {(inputs: Feedback_SendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wird gesendet...`)
};

const ru_feedback_sending = /** @type {(inputs: Feedback_SendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Отправляем...`)
};

const it_feedback_sending = /** @type {(inputs: Feedback_SendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invio in corso...`)
};

/**
* | output |
* | --- |
* | "Sending..." |
*
* @param {Feedback_SendingInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const feedback_sending = /** @type {((inputs?: Feedback_SendingInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Feedback_SendingInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_feedback_sending(inputs)
	if (locale === "pt-BR") return pt_br2_feedback_sending(inputs)
	if (locale === "es") return es_feedback_sending(inputs)
	if (locale === "fr") return fr_feedback_sending(inputs)
	if (locale === "de") return de_feedback_sending(inputs)
	if (locale === "ru") return ru_feedback_sending(inputs)
	if (locale === "it") return it_feedback_sending(inputs)
	return en_feedback_sending(inputs)
});